var _rect, _path, _path2, _path3;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgDiscover(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 24,
    width: 35,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    fill: "#fff",
    height: 23,
    rx: 3.5,
    stroke: "#d9d9d9",
    width: 34,
    x: 0.5,
    y: 0.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15 23l19-5.75V20a3 3 0 01-3 3z",
    fill: "#fd6020"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.185 9.11c.365 0 .784.054 1.097.269v1.075a1.457 1.457 0 00-1.097-.538 1.591 1.591 0 00-1.463 1.666v.107c0 .86.68 1.504 1.515 1.504.418 0 .784-.215 1.045-.537v1.075c-.366.161-.731.269-1.15.269-1.306 0-2.352-1.129-2.352-2.472 0-1.397 1.046-2.525 2.405-2.418zm8.206 3.224l1.254-3.224h.94L23.651 14h-.47l-1.934-4.89h.942zM11.004 9.003c.47 0 .94.215 1.307.537l-.471.646c-.21-.215-.47-.377-.732-.377-.313-.054-.575.215-.628.538 0 .268.158.376.68.59 1.045.43 1.307.752 1.36 1.397v.161c-.053.86-.733 1.505-1.569 1.451-.627 0-1.255-.323-1.568-.914l.575-.59c.157.375.523.644.941.644h.052c.314 0 .627-.322.627-.698a.568.568 0 00-.26-.484c-.21-.107-.42-.215-.629-.268-.835-.269-1.096-.645-1.096-1.29v-.053c.052-.752.68-1.344 1.41-1.29zm-5.436.107c1.254.054 2.247 1.13 2.195 2.418 0 .699-.314 1.343-.836 1.826-.47.377-1.045.591-1.62.538H4V9.11zm3.45 4.783h-.89V9.11h.89zm19.494-3.977h-1.62v1.075h1.568v.806h-1.568v1.289h1.62v.807h-2.508V9.11h2.508zm1.882-.806c1.045 0 1.62.484 1.62 1.397.052.698-.418 1.29-1.045 1.397l1.41 1.988h-1.097l-1.202-1.934h-.104v1.934h-.89V9.11zm-25.245.806h-.26v3.17h.26c.418.054.889-.108 1.203-.376.313-.322.47-.752.47-1.235 0-.43-.157-.86-.47-1.183-.314-.268-.785-.43-1.203-.376zm24.827 1.397h.26c.575 0 .837-.269.837-.753 0-.429-.262-.698-.837-.698h-.26z",
    fill: "#000"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M18.948 9c-1.307 0-2.404 1.075-2.404 2.471 0 1.344 1.045 2.472 2.404 2.526s2.404-1.075 2.457-2.472C21.352 10.128 20.307 9 18.948 9z",
    fill: "#fd6020",
    fillRule: "evenodd"
  })));
}

export default __webpack_public_path__ + "media/images/consumer/signup/payment/credit-card/discover-fde7fc7cf60d152558f9720735244b22.svg";
export { SvgDiscover as Component };